import { joinURL } from 'ufo';
import type { ProviderGetImage } from '@nuxt/image';

export const getImage: ProviderGetImage = url => {
  const config = useRuntimeConfig();
  const baseCDN = config.public.APP_BASE_CDN;
  const baseURL = config.public.siteUrl as string;

  if (baseCDN && /^https?:\/\//i.test(url)) {
    const href = new URL(url)?.href;
    if (!new RegExp(baseCDN).test(href)) return { url };
  }

  const isSvg = /\.svgz?($|\?)|^(?!.*\.[a-z0-9]+($|\?)).*$/i.test(url);

  if (isSvg) return { url: joinURL(baseURL, url) };

  return { url: joinURL(baseURL, '/_ipx', 'f_webp', url) };
};
